import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/reports/sportsTransactions/filter'; // Importing Filter component
import Table from 'views/partner/reports/sportsTransactions/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the sports transactions view.
 * @extends JetView
 */
export default class sportsTransactionsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [], // Placeholder for future rows
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Option for Excel export
                        { id: '2', value: 'PDF' }, // Option for PDF export
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for change event
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Get the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Transacciones deportivas', // Filename for the export
                                    ignore: {
                                        detailTittle: true, // Ignore detail title
                                        Action: true, // Ignore Action column
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Transacciones deportivas', // Filename for the export
                                        autowidth: true, // Enable auto width for PDF
                                        ignore: {
                                            detailTittle: true, // Ignore detail title
                                            Action: true, // Ignore Action column
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset the export selection
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [Filter, Table, toolbar], // Layout for the left side
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide', // Wide type for the layout
                    cols: [left], // Columns layout
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view
                $$('pagerA').define('group', 1); // Define pager group
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height(); // Return scroll bottom value
            };
        });
    }
}

// FILE DOCUMENTED
